import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import MaintenanceFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintenanceFilter";
import { FiMenu } from "react-icons/fi";
import { Loader } from "../../../../components/Loader/Loader";
import MaintenanceDropDwonFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintennanceDropDownFilter";
import {
  ABCAnalysis,
  ABCAnalysisFun,
  StoreFilters,
} from "../../../../Redux/Slice/Maintenance/MaintenanceSlice";
import MaintenanceTable from "../../../../components/Tables/MaintenanceTable";
import { useTheme } from "../../../../Themecontext/Themecontext";

const financialYearMonths = [
  { name: "April", id: "04" },
  { name: "May", id: "05" },
  { name: "June", id: "06" },
  { name: "July", id: "07" },
  { name: "August", id: "08" },
  { name: "September", id: "09" },
  { name: "October", id: "10" },
  { name: "November", id: "11" },
  { name: "December", id: "12" },
  { name: "January", id: "01" },
  { name: "February", id: "02" },
  { name: "March", id: "03" },
];

export const AbcAnalysis = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StoreFiltersdata, ABCAnalysisdata } = useSelector(
    (state) => state.MaintenanceSlice,
  );
  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTORE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTOREDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");

  const Firm = Cookies.get("Firm");

  const selectedYearObj = DataMain?.AC_Year_List?.find(
    (y) => String(y.AcYearID) === String(FinancialYear),
  );

  const parseAcYear = (acYearStr) => {
    if (!acYearStr) return null;

    const [start, end] = acYearStr.split(" - ");

    const formatDate = (d) => {
      const [dd, mm, yyyy] = d.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  };

  const financialYearRange = parseAcYear(selectedYearObj?.AcYear);

  const FinYearStart = financialYearRange?.start;
  const FinYearEnd = financialYearRange?.end;

  const getMonthId = (monthValue) => {
    if (!FinYearStart || !FinYearEnd) return "";

    const start = new Date(FinYearStart);
    const end = new Date(FinYearEnd);

    if (isNaN(start) || isNaN(end)) return "";

    const startYear = start.getFullYear();
    const endYear = end.getFullYear();

    const year = Number(monthValue) <= 3 ? endYear : startYear;

    return `${year}${monthValue}`; // ✅ 202604 format
  };

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const [selectedBook, setSelectedBook] = useState("");
  const [selectedBookId, setSelectedBookId] = useState([]);

  const [selecteditemName, setSelecteditemName] = useState("");
  const [selecteditemNameId, setSelecteditemNameId] = useState([]);

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonthId, setSelectedMonthId] = useState([]);

  const [selectedItemGroup, setSelectedItemGroup] = useState("");
  const [selectedItemGroupId, setSelectedItemGroupId] = useState([]);

  const [filter, setFilter] = useState({
    bookName: [],
    itemName: [],
    month: [],
    itemSubGrop: [],
  });

  console.log(filter);


  const [search, setSearch] = useState({
    bookName: "",
    itemName: "",
    month: "",
    itemSubGroup: "",
  });

  const bookNameList =
    StoreFiltersdata?.issueBooks?.map((item) => ({
      label: item.BookTypeName,
      value: item.BookTypeId,
    })) || [];
  const monthList =
    financialYearMonths?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const itemSubGroupList =
    StoreFiltersdata?.ItemSGroup?.map((item) => ({
      label: item.ItemSubGroupName,
      value: item.ItemSubGroupID,
    })) || [];

  const itemNameList =
    StoreFiltersdata?.Inwarditem?.map((item) => ({
      label: item.itemname,
      value: item.itemid,
    })) || [];

  useEffect(() => {
    if (!Firm || !FinancialYear || !FinYearStart) return;

    dispatch(StoreFilters());

    const months =
      filter.month && filter.month.length > 0
        ? filter.month
          .map((m) => getMonthId(String(m).padStart(2, "0")))
          .join(",")
        : getMonthId("04");

    if (!months) return;

    dispatch(
      ABCAnalysis({
        firm: Firm,
        Acyear: FinancialYear,
        IdxMonthNameIDs: months,
      }),
    );
  }, [dispatch, Firm, FinancialYear, FinYearStart]);

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);


  const handleSubmit1 = () => {
    dispatch(ABCAnalysisFun());

    dispatch(
      ABCAnalysis({
        firm: Firm,
        Acyear: FinancialYear,
        BookIDs: selectedBookId.join(","),
        ItemSubGrpIDs: selectedItemGroupId.join(","),
        ItemIDs: selecteditemNameId.join(","),
        IdxMonthNameIDs: selectedMonthId
          ? getMonthId(String(selectedMonthId).padStart(2, "0"))
          : getMonthId("04"),
      })
    );



  };


  const handleSubmit = () => {
    dispatch(ABCAnalysisFun());

    dispatch(
      ABCAnalysis({
        firm: Firm,
        Acyear: FinancialYear,
        BookIDs: filter.bookName.join(","),
        ItemSubGrpIDs: filter.itemSubGroup.join(","),
        ItemIDs: filter.itemName.join(","),
        IdxMonthNameIDs: filter.month
          ? getMonthId(String(filter.month).padStart(2, "0"))
          : getMonthId("04"),
      })
    );

    setShowFilter(false);

  };

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type] || [];

      if (type === "month") {
        return {
          ...prev,
          [type]: selected.includes(item.value) ? [] : [item.value],
        };
      }

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const columns = [
    {
      label: "class",
      key: "class",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: " Item Count ", key: "itemcount", align: "right" },
    { label: "issued Qty", key: "ConsQty", align: "right", format: "true" },
    {
      label: "Consumption Value",
      key: "CostAmount",
      align: "right",
      format: "true",
    },
    { label: "Cons. %", key: "ConsValuePct", align: "right", format: "true" },
    {
      label: "Cum Cons. %",
      key: "ProgressiveConsValuePct",
      align: "right",
      format: "true",
    },
  ];

  const initialData = (ABCAnalysisdata?.Summ || []).map((row) => ({
    class: row.class,
    itemcount: row.itemcount,
    ConsQty: row.ConsQty,
    CostAmount: row.CostAmount,
    ConsValuePct: row.ConsValuePct,
    ProgressiveConsValuePct: row.ProgressiveConsValuePct,
  }));

  const columns1 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "item Item",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Unit",
      key: "UnitName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Rate", key: "Rate", align: "right" },
    { label: "issued Qty", key: "ConsQty", align: "right", format: "true" },
    {
      label: "Consumption Value",
      key: "CostAmount",
      align: "right",
      format: "true",
    },
    { label: "Cons. %", key: "ConsValuePct", align: "right", format: "true" },
    {
      label: "Cum Cons. %",
      key: "ProgressiveConsValuePct",
      align: "right",
      format: "true",
    },
    { label: "Class", key: "Class", align: "left" },
  ];

  const initialData1 = (ABCAnalysisdata?.Dtl || []).map((row) => ({
    ItemName: row.ItemName,
    UnitName: row.UnitName,
    Rate: row.Rate,
    ConsQty: row.ConsQty,
    CostAmount: row.CostAmount,
    ConsValuePct: row.ConsValuePct,
    ProgressiveConsValuePct: row.ProgressiveConsValuePct,
    Class: row.Class,
  }));

  if (!StoreFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ABCAnalysisdata || ABCAnalysisdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        minHeight: "100vh",
      }}
    >
   
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <MaintenanceFilterBox
              title="Book Name"
              items={bookNameList}
              search={search.bookName}
              setSearch={(val) => handleSearch("bookName", val)}
              selectedItems={filter.bookName}
              toggleItem={(item) => toggleItem("bookName", item)}
              selectAll={() => selectAll("bookName", bookNameList)}
            />

            <MaintenanceFilterBox
              title="Item Name"
              items={itemNameList}
              search={search.itemName}
              setSearch={(val) => handleSearch("itemName", val)}
              selectedItems={filter.itemName}
              toggleItem={(item) => toggleItem("itemName", item)}
              selectAll={() => selectAll("itemName", itemNameList)}
            />

            <MaintenanceFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filter.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            <MaintenanceFilterBox
              title="ItemSub Group"
              items={itemSubGroupList}
              search={search.itemSubGroup}
              setSearch={(val) => handleSearch("itemSubGroup", val)}
              selectedItems={filter.itemSubGroup}
              toggleItem={(item) => toggleItem("itemSubGroup", item)}
              selectAll={() => selectAll("itemSubGroup", itemSubGroupList)}
            />

            <Button
              onClick={handleSubmit}
              style={{
                width: "100%",
                // height: "44px",
                padding:"12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="g-2 align-items-end ">
          {/* DATE */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDwonFilterBox
              label="Book Name"
              data={bookNameList}
              selectedValue={selectedBook}
              setSelectedValue={setSelectedBook}
              selectedId={selectedBookId}
              setSelectedId={setSelectedBookId}
              placeholder="Select Book Name"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDwonFilterBox
              label="Item Name"
              data={itemNameList}
              selectedValue={selecteditemName}
              setSelectedValue={setSelecteditemName}
              selectedId={selecteditemNameId}
              setSelectedId={setSelecteditemNameId}
              placeholder="Select Item Name"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDwonFilterBox
              label="Month"
              data={monthList}
              selectedValue={selectedMonth}
              setSelectedValue={setSelectedMonth}
              selectedId={selectedMonthId}
              setSelectedId={setSelectedMonthId}
              placeholder="Select Month Name"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
              isMulti={false}
            />
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDwonFilterBox
              label="Item Group"
              data={itemSubGroupList}
              selectedValue={selectedItemGroup}
              setSelectedValue={setSelectedItemGroup}
              selectedId={selectedItemGroupId}
              setSelectedId={setSelectedItemGroupId}
              placeholder="Select ItemSub Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* BUTTON */}
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="mt-3 hover-scale-btn "
          >
            <button
              onClick={handleSubmit1}
              style={{
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                height: "45px",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          MACHINE GROUPWISE
        </div>

        <MaintenanceTable columns={columns} data={initialData} />
      </div>

      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          MACHINE GROUPWISWE DETAIL
        </div>

        <MaintenanceTable columns={columns1} data={initialData1} />
      </div>
    </div>
  );
};

export default AbcAnalysis;
